class ResetAllStore {
  resetMethods: (() => void)[] = [];

  setDefaultValues() {
    this.resetMethods = [];
  }

  addResetMethod(resetMethod: () => void) {
    this.resetMethods.push(resetMethod);
  }

  reset() {
    this.resetMethods.forEach((resetMethod) => {
      resetMethod();
    });
  }
}

const resetAllStore = new ResetAllStore();

export { resetAllStore, ResetAllStore };
